/**
 * Static Page Loader
 *
 * Loads markdown content for static pages (Help, Safety, Cancellation).
 *
 * Privacy and Terms are no longer loaded here — they are served from the
 * database via LegalDocumentPage (SCRUM-2203 / MVP 1.40.3).
 *
 * @module loaders/staticPageLoader
 */

// Import markdown files as raw text (requires Vite raw loader)
import helpContent from '../content/pages/help.md?raw';
import safetyContent from '../content/pages/safety.md?raw';
import cancellationContent from '../content/pages/cancellation.md?raw';

const STATIC_PAGES = {
  help: {
    content: helpContent,
    title: null,
    description: 'Find answers to common questions about booking, cancellations, and using Outdoor Guides.'
  },
  safety: {
    content: safetyContent,
    title: null,
    description: 'Important safety information for outdoor experiences on Outdoor Guides.'
  },
  cancellation: {
    content: cancellationContent,
    title: null,
    description: 'Understand cancellation policies and refund options for bookings.'
  }
};

export function staticPageLoader(pageSlug) {
  return async function loader() {
    try {
      const page = STATIC_PAGES[pageSlug];

      if (!page) {
        throw new Error(`Page not found: ${pageSlug}`);
      }

      return {
        content: page.content,
        title: page.title,
        description: page.description,
        error: null
      };
    } catch (error) {
      console.error(`Error loading static page ${pageSlug}:`, error);
      return {
        content: null,
        title: null,
        description: null,
        error: error.message || 'Failed to load page content'
      };
    }
  };
}

export default staticPageLoader;
